/**
 * `/merchandising/styles/$styleId` — redirect-only. The Style File itself
 * lives at `/merchandising/styles/$styleId/overview`; this bare URL exists
 * for old bookmarks/links (garment Increment 1, M2 split —
 * `docs/product/garment-os-screen-build-plan.md` §A).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/merchandising/styles/$styleId/overview", params });
  },
});
